import { useHead } from "@vueuse/head";
import { computed, unref } from "vue";
import { platformStore } from "@/main";

let siteTitle = "hello";
let separator = "|";

export const usePageTitle = (pageTitle) =>
  useHead(
    computed(() => ({
      title: `${unref(pageTitle)} ${separator} ${siteTitle}`,
    })),
  );

export const useMeta = (data) => {
  return useHead({
    ...data,
    title: `${data.title} ` + (platformStore.design.platformName ? "| " + platformStore.design.platformName : "Studea"),
  });
};
